import React from 'react';
export var AnchorContext = React.createContext({});
//# sourceMappingURL=anchor-context.js.map